import React from 'react';
import { Button } from '@/components/ui/button';
import { UserPlus, LogIn, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useChatInterface } from '@/contexts/ChatInterfaceContext';
import { useIsMobile } from '@/hooks/use-mobile';

const AnonymousSidebarNav: React.FC = () => {
  const navigate = useNavigate();
  const { currentPosit, sidebarOpen, toggleSidebar } = useChatInterface();
  const isMobile = useIsMobile();

  // Helper function to handle navigation with auto-close on mobile
  const handleNavigationClick = (path: string) => {
    navigate(path);
    // Auto-close sidebar on mobile after navigation
    if (isMobile && sidebarOpen) {
      toggleSidebar();
    }
  };

  return (
    <nav className="flex-1 space-y-6 px-4 py-6">
      {/* Current Posit Info */}
      {currentPosit && (
        <div className="space-y-3">
          <div className="text-center">
            <h2 className="text-lg font-semibold text-foreground mb-1">
              {currentPosit.title}
            </h2>
            <p className="text-sm text-muted-foreground">
              Chat with this AI assistant
            </p>
          </div>
        </div>
      )}

      {/* Authentication Actions */}
      <div className="space-y-3">
        <Button 
          onClick={() => handleNavigationClick('/signup')}
          className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-medium py-2.5"
        >
          <UserPlus className="h-4 w-4 mr-2" />
          Sign Up Free
        </Button>
        
        <Button 
          variant="outline"
          onClick={() => handleNavigationClick('/login')}
          className="w-full border-border hover:bg-muted/50 font-medium py-2.5"
        >
          <LogIn className="h-4 w-4 mr-2" />
          Sign In
        </Button>
        
        <Button 
          variant="ghost"
          onClick={() => handleNavigationClick('/public-posits')}
          className="w-full hover:bg-muted/50 font-medium py-2.5 text-muted-foreground hover:text-foreground"
        >
          <Search className="h-4 w-4 mr-2" />
          Explore Posits
        </Button>
      </div>

      {/* Value Proposition */}
      <div className="space-y-3 py-4 border-t border-border">
        <div className="space-y-2">
          <h3 className="text-sm font-medium text-foreground">
            Create Your Digital Brain
          </h3>
          <p className="text-xs text-muted-foreground leading-relaxed">
            Build an AI-powered knowledge base with your expertise. Turn your insights into an interactive chat experience that works 24/7.
          </p>
        </div>
        
        <div className="space-y-1">
          <div className="text-xs text-muted-foreground">
            ✓ Free to get started
          </div>
          <div className="text-xs text-muted-foreground">
            ✓ No credit card required
          </div>
          <div className="text-xs text-muted-foreground">
            ✓ Monetize your expertise
          </div>
        </div>
      </div>


    </nav>
  );
};

export default AnonymousSidebarNav; 